<template>
  <div class="el-box">
    <van-nav-bar
  title="饿了么"
  fixed
  left-arrow
  @click-left="$router.go(-1)"
/>
   <img class="top-pic" src="@/assets/images/el-ban.jpg"/>
   <div class="content">
      <van-button type="warning" round @click="openUrl(elLink)">领红包点外卖</van-button>
     <van-button type="warning" round @click="openUrl(buyLink)">领红包买菜</van-button>
   </div>
    <div class="content">
      <van-button type="warning" round @click="openUrl(link3)">领饿了么红包</van-button>
      <van-button type="warning" round @click="openUrl(link2)">领餐饮红包</van-button>

   </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      elLink:'', // 外卖红包
      buyLink:'', // 买菜的红包
      link2: '',
      link3: '',
    }
  },
    created(){
       this.Post({}, "/taobao/scActivitylinkToolget", res => {
        if (res.states == 1) {
          this.elLink = res.data.data.short_click_url;
        }
      });
      this.Post({code:4}, "/taobao/scActivitylinkToolget", res => {
        if (res.states == 1) {
          this.buyLink = res.data.data.short_click_url;
        }
      });
       this.Post({code:2}, "/taobao/scActivitylinkToolget", res => {
        if (res.states == 1) {
          this.link2 = res.data.data.short_click_url;
        }
      });
       this.Post({code:5}, "/taobao/scActivitylinkToolget", res => {
        if (res.states == 1) {
          this.link3 = res.data.data.short_click_url;
        }
      });
    },
    methods:{
      openUrl(url){
        window.location.href=url;
      }
    },
}
</script>

<style lang="less" scoped>
.el-box{
  box-sizing: border-box;
  min-height: 100vh;
  background: #289ffd;
  padding-top: 46px;
  .top-pic{
    width: 100%;
  }
  .content{
    display: flex;
    justify-content: space-between;
    padding: 20px 50px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/elm/index.vue